"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideMenuItem = void 0;

require("@albelli/arc-3/lib/core.css");

require("@albelli/arc-3/lib/side_menu.css");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Icon = require("../Icon");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SideMenuItem = function SideMenuItem(_ref) {
  var isActive = _ref.isActive,
      href = _ref.href,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["isActive", "href", "children", "className"]);

  var classes = (0, _classnames.default)("arc3-side-menu__button no-link-style", {
    "arc3-side-menu__button--active": isActive
  }, className);
  return _react.default.createElement("a", _extends({
    href: href,
    className: classes
  }, props), _react.default.createElement("div", {
    className: "arc3-side-menu__button__content"
  }, children), _react.default.createElement("div", {
    className: "arc3-side-menu__button__arrow"
  }, _react.default.createElement(_Icon.Icon, {
    name: "slim_arrow_right",
    size: "extra-small"
  })));
};

exports.SideMenuItem = SideMenuItem;
SideMenuItem.propTypes = {
  /** Shows SideMenuItem as selected/active  */
  isActive: _propTypes.default.bool,

  /** SideMenuItem link */
  href: _propTypes.default.string,

  /** SideMenuItem content */
  children: _propTypes.default.any,

  /** Custom CSS classes */
  className: _propTypes.default.string
};